import gsap from 'gsap';
import Modal from 'bootstrap';
export default {
  init() {
    if($('.block-home-hero').length){
      $('.hero-modal').on('click', function(){
        $('#heroModal').fadeIn();
      })

      $('.btn-close-modal').on('click', function(){
        $('#heroModal').fadeOut();
      })

      // Home Hero Block Animation
      var 
        heroTitle = '.block-home-hero .hero-title',
        heroDesc = '.block-home-hero .hero-description',
        heroBtns = '.block-home-hero .hero-buttons',
        heroCompanies = '.companies',
        heroTl = gsap.timeline();
      
      // Hero Sets
      // gsap.set(heroTitle, {autoAlpha:0, y: 100});
      // gsap.set(heroDesc, {autoAlpha:0, y: 100});
      // gsap.set(heroBtns, {autoAlpha:0});
      // gsap.set(heroCompanies, {autoAlpha:0});

      // // Hero Animation
      // heroTl
      //   .to(heroTitle, {autoAlpha: 1, y:0, delay: 1})
      //   .to(heroDesc, {autoAlpha: 1, y:0})
      //   .to(heroBtns, {autoAlpha: 1});
      
      //   gsap.to(heroCompanies, {autoAlpha:1, delay:1});
    }
  },
  finalize() {}
}